import { PreflightStatus } from "hoxton-shared/enums/creativex";
import { PLATFORM } from "hoxton-shared/enums/exports";

export const PlatformLabel = {
    [PLATFORM.DOUBLECLICK]: "Google",
    [PLATFORM.DOUBLECLICK_SV]: "Google Studio Dynamic",
    [PLATFORM.FLASHTALKING]: "Flashtalking",
    [PLATFORM.FLASHTALKING_EXCEL]: "Flashtalking Excel",
    [PLATFORM.FLASHTALKING_ASSETS]: "Flashtalking Assets",
    [PLATFORM.TIKTOK]: "TikTok Ads Manager",
    [PLATFORM.FACEBOOK]: "Meta Ads Manager",
    [PLATFORM.OPENDC]: "Open Media Studio",
    [PLATFORM.CREATIVEX]: "CreativeX",
    [PLATFORM.SATALIA]: "Pre-flight",
    [PLATFORM.GENERIC]: "Generic",
    [PLATFORM.GENERIC_LITE]: "Generic Lite"
} as const;

export const PlatformPublishedStatusFilter = {
    All: "all",
    NotPublished: "n",
    NotPublishedToDoubleClick: "npdc",
    NotPublishedToFlashtalking: "npf",
    NotPublishedToOpenDC: "npodc",
    Published: "p",
    PublishedToDoubleClick: "pdc",
    PublishedToFlashtalking: "pf",
    PublishedToOpenDC: "podc"
} as const;

export const PlatformPublishedStatusFilterLabel = {
    [PlatformPublishedStatusFilter.All]: "All",
    [PlatformPublishedStatusFilter.NotPublished]: "Not published",
    [PlatformPublishedStatusFilter.NotPublishedToDoubleClick]: `Not published on ${PlatformLabel[PLATFORM.DOUBLECLICK]}`,
    [PlatformPublishedStatusFilter.NotPublishedToFlashtalking]: `Not published on ${PlatformLabel[PLATFORM.FLASHTALKING]}`,
    [PlatformPublishedStatusFilter.NotPublishedToOpenDC]: `Not published on ${PlatformLabel[PLATFORM.OPENDC]}`,
    [PlatformPublishedStatusFilter.Published]: "Published",
    [PlatformPublishedStatusFilter.PublishedToDoubleClick]: `Published on ${PlatformLabel[PLATFORM.DOUBLECLICK]}`,
    [PlatformPublishedStatusFilter.PublishedToFlashtalking]: `Published on ${PlatformLabel[PLATFORM.FLASHTALKING]}`,
    [PlatformPublishedStatusFilter.PublishedToOpenDC]: `Published on ${PlatformLabel[PLATFORM.OPENDC]}`
} as const;

export const OpenDcCampaignType = {
    Display: "DISPLAY",
    Video: "VIDEO",
    SocialVideo: "SOCIAL_VIDEO",
    SocialStatic: "SOCIAL_STATIC"
} as const;

export const OpenDcCampaignTypeLabel = {
    [OpenDcCampaignType.Display]: "Display",
    [OpenDcCampaignType.Video]: "Video",
    [OpenDcCampaignType.SocialVideo]: "Social Video",
    [OpenDcCampaignType.SocialStatic]: "Social Static"
} as const;

export const CreativeXCampaignType = {
    Brand: "BRAND",
    Creator: "CREATOR"
} as const;

export const CreativeXAssetType = {
    Image: "IMAGE",
    Video: "VIDEO"
} as const;

export const CreativeXScoreFilters = {
    All: "all",
    OverThreshold: "over-[THRESHOLD]",
    UnderThreshold: "under-[THRESHOLD]"
} as const;

export const PreflightStatusFilters = {
    All: "all",
    NotSent: PreflightStatus.NOT_SENT,
    Processing: PreflightStatus.PROCESSING,
    Completed: PreflightStatus.COMPLETED,
    Error: PreflightStatus.ERROR
} as const;
